import Model from '@/models/Model'

export default {
    mixins: [
        Model
    ],

    data() {
        return {
            table: 'companies',
            name: 'company',
            class: 'Modules\\Site\\Entities\\Company'
        }
    },

    methods: {
        lite() {
            return axios({
                method: 'get',
                url: route('api.companies.lite')
            })
            .then(response => {
                if(response.data.success) {
                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
        },

        speakers(company) {
            return axios({
                method: 'get',
                url: route('api.companies.speakers', company)
            })
            .then(response => {
                if(response.data.success) {
                    return response.data.data
                } else {
                    this.$alert(response.data.message, 'Error!', 'error')
                }
            })
            .catch(error => this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error'))
        }
    }
}